<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>供应商对账</span>
          </div>
          <table class="supplier-table">
            <thead @click="bodySlide(0)">
              <tr>
                <th colspan="6">签约信息</th>
              </tr>
            </thead>
            <tbody v-show="tableSlide[0]">
              <tr>
                <th width="100">签约状态</th>
                <td>
                  {{ [7,9].indexOf(editData.custom_level) > -1 ? editData.crm_level_lv_str : '-' }}</td>
                <th width="100">签约日期</th>
                <td>{{ editData.signing_date }}</td>
                <th width="100">合同号</th>
                <td>{{ editData.contract_number }}</td>
              </tr>
              <tr>
                <th>文书老师</th>
                <td>{{ editData.crm_document_str || '-' }}</td>
                <th>申请老师</th>
                <td>{{ editData.crm_writer_str || '-' }}</td>
                <th>咨询老师</th>
                <td>{{ editData.crm_sayer_str || '-' }}</td>
              </tr>
            </tbody>
          </table>

          <table class="supplier-table">
            <thead @click="bodySlide(1)">
              <tr>
                <th colspan="3">申请信息</th>
              </tr>
            </thead>
            <tbody v-show="tableSlide[1]">
              <tr>
                <th>选校信息</th>
                <td>
                  <table border="0" width="500" class="schoolInfo" cellspacing="0">
                    <tr v-for="marjor in schoolMarjor" :key="marjor.id">
                      <td>
                        {{ marjor.sh_name_cn }}
                      </td>
                      <td>
                        <span v-if="marjor.sh_mg_id !== 238">
                          {{ marjor.pf_name_cn }} {{ marjor.pf_name_en }}
                        </span>
                      </td>
                      <td>
                        <el-tag v-if="marjor.status">
                          {{ marjor.status_text }}
                        </el-tag>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th width="100">备注</th>
                <td>{{ editData.crm_school_memo }}</td>
              </tr>

              <template v-if="editData.custom_hope_country && editData.custom_hope_country.length">
                <tr v-for="countryId in editData.custom_hope_country.filter((c) => { return ds.applyCountries[c] })" :key="countryId">
                  <th>{{ ds.applyCountries[countryId] }}申请课程</th>
                  <td>
                    <el-tag v-for="item in countryCourse(countryId)" :key="item.id">
                      {{ item.value }}
                    </el-tag>
                    <el-tag size="small" v-if="countryId === 471 && editData.crm_gpa" type="success">
                      GPA：{{ editData.crm_gpa }}
                    </el-tag>
                  </td>
                </tr>
              </template>

              <tr v-if="ds.direction.length > 0">
                <th width="100">申请专业</th>
                <td>
                  <template v-if="editData.custom_hope_way">
                    <el-tag v-for="item in ds.direction.filter((v) => { return editData.custom_hope_way.indexOf(v.id) > -1 })" :key="item.id">
                      {{ item.value }}
                    </el-tag>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="supplier-table">
            <thead @click="bodySlide(2)">
              <tr>
                <th colspan="6">财务信息</th>
              </tr>
            </thead>
            <tbody v-show="tableSlide[2]">
              <tr>
                <th width="100">合同总额</th>
                <td width="150">{{ editData.crm_money_all }}</td>
                <th width="100">首款</th>
                <td>{{ editData.crm_gathering }}</td>
                <th width="100">尾款</th>
                <td>{{ editData.crm_final_pay }}</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th width="100">首款缴费时间</th>
                <td>{{ editData.crm_gathering_time }}</td>
                <th width="100">尾款缴费时间</th>
                <td>{{ editData.crm_final_pay_time }}</td>
              </tr>
            </tbody>
          </table>
          <div class="basic-second-title"><i/><em>学生回访</em></div>
          <jm-tableList
            style="margin-top:10px"
            :url="`/index/visit/paginate/userid/${$route.params.id}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import * as UserApi from '@/api/user.js';
import _ from 'lodash';

export default {
  data() {
    return {
      editData: {},
      schoolMarjor: [],
      ds: {
        applyCountries: {
          83: '日本',
          30: '英国',
          31: '澳洲',
          471: '美国',
        },
        courses: [],
        direction: []
      },
      tableSlide: [true, true, true],
    };
  },
  methods: {
    bodySlide(idx) {
      this.$set(this.tableSlide, idx, !this.tableSlide[idx]);
    },
    /**
     *
     */
    getSchoolMajor() {
      this.$http._get({
        url: `/index/student/applySchoolMarjor/id/${this.$route.params.id}`,
      }).then(({ data }) => {
        this.schoolMarjor = data;
      });
    },
    /**
     * 初始化用户数据
     */
    getStudent() {
      const userid = this.$route.params.id;
      if (!userid) {
        return Promise.resolve(false);
      }
      return UserApi.getBaseInfo(userid).then(({ data }) => {
        this.editData = Object.assign({}, this.editData, data);
      });
    },
    /**
     * 国家课程数据字典
     */
    getCountryCourse() {
      this.$http
        ._get({
          url: '/index/api_base/countryCourse'
        })
        .then((res) => {
          this.ds.courses = _.groupBy(res.data, (o) => {
            return o.country;
          });
        });
    },
    /**
     * 专业字典
     */
    getDirectionDict() {
      this.$http
        ._get({
          url: '/index/api_base/directionDict'
        })
        .then(({ data }) => {
          this.ds.direction = data;
        });
    },
    countryCourse(country) {
      country = country.toString();

      if (this.ds.courses[country] && this.ds.courses[country].length) {
        return this.ds.courses[country].filter((v) => {
          return this.editData.custom_course.indexOf(v.id) > -1;
        });
      }
      return [];
    }
  },
  computed: {},
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  created() {
    this.getStudent();
    this.getCountryCourse();
    this.getDirectionDict();
    this.getSchoolMajor();
  }
};
</script>

<style>
  .supplier-table{
    border-spacing: 0;
    border-bottom: 1px #b8c4ce solid;
    border-left: 1px #b8c4ce solid;
    width: 100%;
    /* margin-left: 20px; */
  }
  .supplier-table thead th{
    height:38px;
    text-align: left;
    padding: 0 8px;
    background: #01142d;
    color: #fff;
  }
  .supplier-table tbody th{
    height:38px;
    text-align: left;
    padding: 0 8px;
    border-right: solid 1px #b8c4ce;
    border-top: solid 1px #b8c4ce;
  }
  .supplier-table td{
    height:36px;
    box-sizing: border-box;
    padding: 8px 6px;
    font-weight: normal;
    color: #707C9A;
    border-right: solid 1px #b8c4ce;
    border-top: solid 1px #b8c4ce;
  }
  .supplier-table td>span{
    margin-right: 10px;
  }
  .schoolInfo td {
    border: none;
  }
</style>
